import React, { FC, SVGProps } from 'react';

export const SelectCheckbox: FC<SVGProps<SVGSVGElement>> = ({ ...rest }) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...rest}>
      <path d="M20 2H8C6.897 2 6 2.897 6 4V16C6 17.103 6.897 18 8 18H20C21.103 18 22 17.103 22 16V4C22 2.897 21.103 2 20 2ZM8 16V4H20L20.002 16H8Z" />
      <path d="M4 8.00001H2V20C2 21.103 2.897 22 4 22H16V20H4V8.00001ZM12.933 11.519L11.207 9.79301L9.793 11.207L13.067 14.481L18.769 7.64101L17.231 6.35901L12.933 11.519Z" />
    </svg>
  );
};
